import React from 'react';
import './CourseView.less';
import Courses from '../../../data/courses.js';
import { Row, Column, Item } from 'react-plan';
import { Link } from 'react-router';
import Button from '../../../common/js/app/Button/Button.jsx';

type Props = {

}

const strings = {
  curriculum: 'Curriculum',
  lectureNumber: 'Lecture #',
  lectureName: 'Lecture name',
  duration: 'Duration',
  assessment: 'assessment',
  features: 'features',
  instructor: 'instructor',
  enroll: 'Enroll'
};

class CourseView extends React.Component {

  description: 'Shows a single course view.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.state = {
      course: null
    };
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  componentWillMount() {
    const course = Courses.filter(course => course.id === this.props.params.courseId)[0];
    (course) ? this.setState({ course: course }) : this.context.router.push('404');
  }
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}

  render() {
    let Curricucum;
    if (this.props.params.courseId == '5799c9b4732db5d32485c166') {
      Curricucum = (
        <span>
          <p className="curriculum-title">FUNDAMENTALS OF ORBITAL MECHANICS</p>
          <Row className="row">
            <Column>Mathematics for two body problem</Column>
            <Column size="20%" className="txt-align-r">15:29</Column>
          </Row>
          <Row className="row">
            <Column>Earth orbit geometry</Column>
            <Column size="20%" className="txt-align-r">13:45</Column>
          </Row>
          <Row className="row">
            <Column>Orbit perturbations</Column>
            <Column size="20%" className="txt-align-r">17:33</Column>
          </Row>
          <Row className="row">
            <Column>Orbit design process</Column>
            <Column size="20%" className="txt-align-r">20:31</Column>
          </Row>
          <p className="curriculum-title">THERMAL DESIGN OF SATELLITE</p>
          <Row className="row">
            <Column>Why thermal design is needed?</Column>
            <Column size="20%" className="txt-align-r">03:25</Column>
          </Row>
          <Row className="row">
            <Column>How the temperature of each part of a satellite is determined?</Column>
            <Column size="20%" className="txt-align-r">17:03</Column>
          </Row>
          <Row className="row">
            <Column>Calculation of solar heat input depending on orbit-sun light relationships</Column>
            <Column size="20%" className="txt-align-r">16:21</Column>
          </Row>
          <Row className="row">
            <Column>Design freedom for thermal design</Column>
            <Column size="20%" className="txt-align-r">11:03</Column>
          </Row>
          <Row className="row">
            <Column>Thermal design sequence</Column>
            <Column size="20%" className="txt-align-r">9:26</Column>
          </Row>
          <p className="curriculum-title">FUNDAMENTALS OF SPACECRAFT ATTITUDE DYNAMICS AND CONTROL</p>
          <Row className="row">
            <Column>Attitude representation (DCM and Quarternion)</Column>
            <Column size="20%" className="txt-align-r">27:11</Column>
          </Row>
          <Row className="row">
            <Column>Equation of motion of rigid bodt (Euler rotational motion)</Column>
            <Column size="20%" className="txt-align-r">11:54</Column>
          </Row>
          <h3 className="m-t-xxl">{ strings.instructor }</h3>

            <Row className="m-t-xl">
            <Column className="m-r m-b" size="33%" small="100%">
              <div>
                <img className="img-prof" src={ require('../../../img-layout/img16-9-nakazuka.jpg') } alt="prof-img" />
              </div>
              </Column>
              <Column className="" small="100%">
                <h3>PROFESSOR NAKASUKA</h3>
                <p className="m-t">Prof.Nakasuka graduated from University of Tokyo in 1983 and got Ph.D in 1988. He joined IBM Research during 1988-1990, and then worked for Department of Aeronautics and Astronautics, University of Tokyo as a lecturer in 1990, as an Associate Professor in 1993, and became a Professor in 2004. He developed and launched seven micro/nano/pico-satellites successfully.He is a member of JSASS, SICE, and IAA, and the Chairperson of IFAC Aerospace Technical Committee and UNISEC-GLOBAL.He has been a member of Space Policy Committee of Cabinet Office of Japan since 2012.</p>
              </Column>
            </Row>
            <Row className="m-t-xl m-b-xxl">
              <Column>
                <a className="no-underline txt-center" href="https://app.worldspaceschool.jp/auth/login" >
                  <Button>{ strings.enroll }</Button>
                </a>
              </Column>
            </Row>
   </span>
      );
    }  if (this.props.params.courseId == '5799c9b47c2bb37849d2dc8f'){
      Curricucum = (
        <span>
          <p className="curriculum-title">MESSAGE FROM SPACE</p>
          <Row className="row">
            <Column>Introduction / System Engineering</Column>
            <Column size="20%" className="txt-align-r">10:30</Column>
          </Row>
          <Row className="row">
            <Column>ISS "KIBO" EXPERIMENTS</Column>
            <Column size="20%" className="txt-align-r">11:12</Column>
          </Row>
          <Row className="row">
            <Column>Space Exploration & International Cooperation</Column>
            <Column size="20%" className="txt-align-r">01:48</Column>
          </Row>
          <Row className="row">
            <Column>View from space</Column>
            <Column size="20%" className="txt-align-r">07:33</Column>
          </Row>
          <h3 className="m-t-xxl">{ strings.instructor }</h3>

            <Row className="m-t-xl">
            <Column className="m-r m-b" size="33%" small="100%">
              <div>
                <img className="img-prof" src={ require('../../../img-layout/img16-9.jpg') } alt="prof-img" />
              </div>
              </Column>
              <Column className="" small="100%">
                <h3>Astronaut Naoko Yamazaki</h3>
                <p className="m-t">Naoko Yamazaki earned a Bachelor of Science degree majored in Aerospace Engineering from the University of Tokyo in March 1993.<br />
                She spent one year as an exchange student at the University of Maryland in the U.S. from 1994 till 1995.
                In March 1996, she earned a Master of Science degree majored in Aerospace Engineering from the University of Tokyo.<br />
                In April 1996, she started working for Japan Aerospace Exploration Agency (JAXA) (former NASDA).
                In February 1999, she was selected as an astronaut candidate by JAXA and was certified as an astronaut in September 2001.<br />
                In May 2004, she completed Soyuz-TMA Flight Engineer training at the Yuri Gagarin Cosmonauts Training Center in Star City, Russia.<br />
                In February 2006, she was certified as Mission Specialist by NASA.<br />
                On April 5, 2010 Yamazaki was onboard Space Shuttle Discovery as a mission specialist on the crew of STS-131, an assembly & resupply mission to the International Space Station (ISS). She returned to Earth on April 20, 2010.
                Yamazaki retired from JAXA on August 31, 2011 and has been serving as a member of Japan Space Policy Committee and an adviser of Young Astronaut Club (YAC), a visiting professor at Ritsumeikan University and Joshibi University of Art and Design, etc.</p>
              </Column>
            </Row>
            <Row className="m-t-xl m-b-xxl">
              <Column>
                 <a className="no-underline txt-center" href="https://app.worldspaceschool.jp/auth/login" >
                  <Button>{ strings.enroll }</Button>
                </a>
              </Column>
            </Row>
        </span>
      );
    } if (this.props.params.courseId == '5799c9b47c2bb37849d2d3cd'){
      Curricucum = (
        <span>
          <p className="curriculum-title">Remote Sensing/GIS</p>
          <Row className="row">
            <Column>Principal of remote sensing</Column>
            <Column size="20%" className="txt-align-r">06:07</Column>
          </Row>
          <Row className="row">
            <Column>Characteristics of electro-magnetic radiation</Column>
            <Column size="20%" className="txt-align-r">02:23</Column>
          </Row>
          <Row className="row">
            <Column>Classification of electro-magnetic radiation in wave length</Column>
            <Column size="20%" className="txt-align-r">04:18</Column>
          </Row>
          <Row className="row">
            <Column>Image Resolution and Image Interpretation</Column>
            <Column size="20%" className="txt-align-r">08:30</Column>
          </Row>
          <h3 className="m-t-xxl">{ strings.instructor }</h3>

            <Row className="m-t-xl">
            <Column className="m-r m-b" size="33%" small="100%">
              <div>
                <img className="img-prof" src={ require('../../../img-layout/MasahikoNagai.jpg') } alt="prof-img" />
              </div>
              </Column>
              <Column className="" small="100%">
                <h3>Dr. Masahiko Nagai</h3>
                <p className="m-t">Dr. Masahiko Nagai is an associate professor at the Graduate School of Sciences and Technology for Innovation, Yamaguchi University, Japan and the School of Engineering and Technology, Asian Institute of Technology (AIT), Thailand. He received his doctoral degree in engineering from the University of Tokyo in 2005. From 2005 to 2010, he was a member of the University of Tokyo's Center for Spatial Information Science, and from 2010 to 2014, he worked at JAXA (Japan Aerospace eXploration Agency) as a coordinator of satellite data analysis for disaster management in Sentinel Asia.</p>
              </Column>
            </Row>
            <Row className="m-t-xl m-b-xxl">
              <Column>
                 <a className="no-underline txt-center" href="https://app.worldspaceschool.jp/auth/login" >
                  <Button>{ strings.enroll }</Button>
                </a>
              </Column>
            </Row>
        </span>
      );
    }

    return (
      (this.state.course) ?
        <div className="course-view">
          <Item wide="hide" large="hide" medium="hide">
            <img alt={ this.state.course.title } className="cover" src={ this.state.course.cover } />
          </Item>
          <Item small="hide">
            <img alt={ this.state.course.title } className="cover" src={ this.state.course.cover } />
          </Item>
          <div className="bloc-medium m-t">
            <h1 className="txt-center">{ this.state.course.title }</h1>
            <div className="m-t">
              <p>{ this.state.course.description }</p>
            </div>
            <h3 className="m-t-xxl">{ strings.curriculum }</h3>

            <Row className="header">
              <Column>{ strings.lectureName }</Column>
              <Column className="txt-align-r" size="20%">{ strings.duration }</Column>
            </Row>
            { Curricucum }
          </div>
        </div>
        :
        <div className="course-view"></div>
    );
  }
  /* End React Component LifeCycle Methods */
}

CourseView.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default CourseView;

//Unit test entry point
export const CourseViewTest = CourseView;


/** WEBPACK FOOTER **
 ** ./src/js/views/CourseView/CourseView.jsx
 **/